export const punjabiFlashcards = {
  categories: [
  {
    pa: "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ",
    rm: "Sat Sri Akal",
    en: "Hello / Greetings (Sikh)",
  },
  {
    pa: "السلام علیکم",
    rm: "Assalam-o-Alaikum",
    en: "Peace be upon you (Muslim greeting)",
  },
  {
    pa: "کی حال اے؟",
    rm: "Ki haal ae?",
    en: "How are you?",
  },
  {
    pa: "تسی کیویں او؟",
    rm: "Tusi kiwein o?",
    en: "How are you? (formal)",
  },
  {
    pa: "میں ٹھیک ہاں",
    rm: "Mein theek haan",
    en: "I am fine",
  },
  {
    pa: "شکریہ",
    rm: "Shukriya",
    en: "Thank you",
  },
  {
    pa: "بہت شکریہ",
    rm: "Bohat shukriya",
    en: "Thank you very much",
  },
  {
    pa: "کوئی گل نہیں",
    rm: "Koi gal nahi",
    en: "You're welcome / No problem",
  },
  {
    pa: "معاف کرنا",
    rm: "Maaf karna",
    en: "Excuse me / Sorry",
  },
  {
    pa: "مہربانی کرو",
    rm: "Meherbani karo",
    en: "Please",
  },
  {
    pa: "جی",
    rm: "Jee",
    en: "Yes (respectful)",
  },
  {
    pa: "ہاں",
    rm: "Haan",
    en: "Yes",
  },
  {
    pa: "نہیں",
    rm: "Nahi",
    en: "No",
  },
  {
    pa: "ٹھیک اے",
    rm: "Theek ae",
    en: "Okay / Alright",
  },
  {
    pa: "مینوں سمجھ نہیں آئی",
    rm: "Mainu samajh nahi aayi",
    en: "I don't understand",
  },
  {
    pa: "تسی انگریزی بولدے او؟",
    rm: "Tusi angrezi bolde o?",
    en: "Do you speak English? (formal - to male)",
  },
  {
    pa: "تسی انگریزی بولدیاں او؟",
    rm: "Tusi angrezi boldeeyan o?",
    en: "Do you speak English? (formal - to female)",
  },
  {
    pa: "تو انگریزی بولدا اے؟",
    rm: "Tu angrezi bolda ae?",
    en: "Do you speak English? (informal - to male)",
  },
  {
    pa: "تو انگریزی بولدی اے؟",
    rm: "Tu angrezi boldi ae?",
    en: "Do you speak English? (informal - to female)",
  },
  {
    pa: "اے کی اے؟",
    rm: "Ae ki ae?",
    en: "What is this?",
  },
  {
    pa: "اے کِنّے دا اے؟",
    rm: "Ae kinne da ae?",
    en: "How much is this?",
  },
  {
    pa: "کتھے اے؟",
    rm: "Kitthe ae?",
    en: "Where is...?",
  },
  {
    pa: "باتھ روم کتھے اے؟",
    rm: "Bathroom kitthe ae?",
    en: "Where is the bathroom?",
  },
  {
    pa: "ریلوے اسٹیشن کتھے اے؟",
    rm: "Railway station kitthe ae?",
    en: "Where is the railway station?",
  },
  {
    pa: "ایئرپورٹ کتھے اے؟",
    rm: "Airport kitthe ae?",
    en: "Where is the airport?",
  },
  {
    pa: "مدد کرو!",
    rm: "Madad karo!",
    en: "Help!",
  },
  {
    pa: "مینوں مدد دی لوڑ اے",
    rm: "Mainu madad di lor ae",
    en: "I need help",
  },
  {
    pa: "میں کھو گیا واں",
    rm: "Mein kho gaya vaan (m)",
    en: "I am lost (male)",
  },
  {
    pa: "میں کھو گئی آں",
    rm: "Mein kho gayi aan (f)",
    en: "I am lost (female)",
  },
  {
    pa: "کی تسی میری مدد کر سکدے او؟",
    rm: "Ki tusi meri madad kar sakde o?",
    en: "Can you help me? (formal - to male)",
  },
  {
    pa: "کی تسی میری مدد کر سکدیاں او؟",
    rm: "Ki tusi meri madad kar sakdeeyan o?",
    en: "Can you help me? (formal - to female)",
  },
  {
    pa: "آہستہ بولو",
    rm: "Ahista bolo",
    en: "Speak slowly",
  },
  {
    pa: "فیر کہو",
    rm: "Phir kaho",
    en: "Say it again",
  },
  {
    pa: "میں بیمار آں",
    rm: "Mein bimar aan",
    en: "I am sick",
  },
  {
    pa: "مینوں ڈاکٹر دی لوڑ اے",
    rm: "Mainu doctor di lor ae",
    en: "I need a doctor",
  },
  {
    pa: "اے بہت مہنگا اے",
    rm: "Ae bohat mehanga ae",
    en: "This is too expensive",
  },
  {
    pa: "کی تسی گھٹ کر سکدے او؟",
    rm: "Ki tusi ghatt kar sakde o?",
    en: "Can you lower the price? (formal - to male)",
  },
  {
    pa: "کی تسی گھٹ کر سکدیاں او؟",
    rm: "Ki tusi ghatt kar sakdeeyan o?",
    en: "Can you lower the price? (formal - to female)",
  },
  {
    pa: "میں اے لینا چاہندا واں",
    rm: "Mein ae lena chahnda vaan (m)",
    en: "I want to take this (male)",
  },
  {
    pa: "میں اے لینی چاہندی آں",
    rm: "Mein ae leni chahndi aan (f)",
    en: "I want to take this (female)",
  },
  {
    pa: "مینوں اے نہیں چاہیدا",
    rm: "Mainu ae nahi chahida",
    en: "I don't want this",
  },
  {
    pa: "میرا نام... اے",
    rm: "Mera naam... ae",
    en: "My name is...",
  },
  {
    pa: "تہاڈا نام کی اے؟",
    rm: "Thahda naam ki ae?",
    en: "What is your name? (formal)",
  },
  {
    pa: "تیرا نام کی اے؟",
    rm: "Tera naam ki ae?",
    en: "What is your name? (informal)",
  },
  {
    pa: "میں ٹھیک آں، شکریہ",
    rm: "Mein theek aan, shukriya",
    en: "I am fine, thank you",
  },
  {
    pa: "چنگا",
    rm: "Changa",
    en: "Good / Okay",
  },
  {
    pa: "بہت چنگا",
    rm: "Bohat changa",
    en: "Very good",
  },
  {
    pa: "ماڑا",
    rm: "Maada",
    en: "Bad",
  },
  {
    pa: "صبح بخیر",
    rm: "Subah bakhair",
    en: "Good morning (Muslim)",
  },
  {
    pa: "شام بخیر",
    rm: "Shaam bakhair",
    en: "Good evening (Muslim)",
  },
  {
    pa: "خدا حافظ",
    rm: "Khuda hafiz",
    en: "Goodbye (Muslim)",
  },
  {
    pa: "فیر ملاں گے",
    rm: "Phir milan ge",
    en: "See you again",
  },
  {
    pa: "سجے پاسے",
    rm: "Sajje paase",
    en: "To the right",
  },
  {
    pa: "کھبے پاسے",
    rm: "Khabbey paase",
    en: "To the left",
  },
  {
    pa: "سدھا",
    rm: "Sidha",
    en: "Straight",
  },
  {
    pa: "نیڑے",
    rm: "Nere",
    en: "Near",
  },
  {
    pa: "دور",
    rm: "Door",
    en: "Far",
  },
  {
    pa: "اج",
    rm: "Aj",
    en: "Today",
  },
  {
    pa: "کل",
    rm: "Kal",
    en: "Tomorrow / Yesterday (context)",
  },
  {
    pa: "ہن",
    rm: "Hun",
    en: "Now",
  },
  {
    pa: "بعد وچ",
    rm: "Baad vich",
    en: "Later",
  },
  {
    pa: "پانی",
    rm: "Pani",
    en: "Water",
  },
  {
    pa: "کھانا",
    rm: "Khana",
    en: "Food",
  },
  {
    pa: "چاء",
    rm: "Chaa",
    en: "Tea",
  },
  {
    pa: "کافی",
    rm: "Coffee",
    en: "Coffee",
  },
  {
    pa: "اے حلال اے؟",
    rm: "Ae halal ae?",
    en: "Is this halal?",
  },
  {
    pa: "مینوں بھکھ لگی اے",
    rm: "Mainu bhukh lagi ae",
    en: "I am hungry",
  },
  {
    pa: "مینوں ترے لگی اے",
    rm: "Mainu tre lagi ae",
    en: "I am thirsty",
  },
  {
    pa: "کنا ٹائم لگے گا؟",
    rm: "Kinna time lage ga?",
    en: "How much time will it take?",
  },
  {
    pa: "پاسپورٹ",
    rm: "Passport",
    en: "Passport",
  },
  {
    pa: "ویزا",
    rm: "Visa",
    en: "Visa",
  },
  {
    pa: "ہوٹل",
    rm: "Hotel",
    en: "Hotel",
  },
  {
    pa: "کمرہ",
    rm: "Kamra",
    en: "Room",
  },
  {
    pa: "میں اک کمرہ بک کروانا چاہندا واں",
    rm: "Mein ik kamra book karwana chahnda vaan (m)",
    en: "I want to book a room (male)",
  },
  {
    pa: "میں اک کمرہ بک کروانی چاہندی آں",
    rm: "Mein ik kamra book karwani chahndi aan (f)",
    en: "I want to book a room (female)",
  },
  {
    pa: "اے بہت ودھیا اے",
    rm: "Ae bohat vadhia ae",
    en: "This is very good",
  },
  {
    pa: "کوئی مسئلہ نہیں",
    rm: "Koi masla nahi",
    en: "No problem",
  },
  {
    pa: "مبارکاں!",
    rm: "Mubarkan!",
    en: "Congratulations!",
  },
  {
    pa: "ودھیا قسمت!",
    rm: "Vadhia kismat!",
    en: "Good luck!",
  },
  {
    pa: "مزے کرو!",
    rm: "Maze karo!",
    en: "Have fun!",
  },
  {
    pa: "تشریف لیایو",
    rm: "Tashreef liayo",
    en: "Please come in (formal)",
  },
  {
    pa: "آرام نال بیٹھو",
    rm: "Aaram naal baitho",
    en: "Sit comfortably",
  },
  {
    pa: "دیکھو",
    rm: "Dekho",
    en: "Look",
  },
  {
    pa: "چھیتی کرو",
    rm: "Chheti karo",
    en: "Hurry up!",
  },
]};
